<template>
  <div>
    <div>
      <v-row>
        <v-col cols="6">
          <v-card v-if="paperNotSelected" max-width="500">
            <v-card-title>Tidning</v-card-title>
            <v-card-text>
              <v-select
                v-model="selectedPublisher"
                label="Välj Titel"
                :items="publishers"
                item-text="name"
                item-value="value"
                @change="publisherSelected"
              />
              <v-select v-if="paperEditions.length > 0"        
                        v-model="selectedEdition"
                        label="Välj Utgåva"
                        :items="paperEditions"
                        item-text="description"
                        return-object        
              />
         
              <v-dialog
                ref="dialog"
                v-model="dateModal"
                :return-value.sync="date"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="Datum"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="date" scrollable locale="sv-se" :first-day-of-week="1">
                  <v-spacer />
                  <v-btn text color="primary" @click="dateModal = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.dialog.save(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
              <v-text-field v-if="paperSelected"
                            v-model="extraDescription"
                            label="Extra beskrivning"
              >
                <template v-slot:append>
                  <v-fade-transition leave-absolute>
                    <v-progress-circular
                      v-if="saving"
                      size="24"
                      color="info"
                      indeterminate
                    />
                    <v-icon v-else
                            @click="save"
                    >
                      save
                    </v-icon>
                  </v-fade-transition>
                </template>
              </v-text-field>
            </v-card-text>
          </v-card>
          <v-card v-else max-width="500">
            <v-card-title primary-title class="pt-2">
              <div>
                <div class="text-h5">
                  {{ selectedPaper.description }}
                </div>
                <div>
                  {{ selectedPaper.startDate | paperDate }} -
                  {{ selectedPaper.endDate | paperDate }}
                </div>
                <div>Pris: {{ selectedPaper.price }} kr</div>
                <div>EAN: {{ selectedPaper.eanCode }}</div>        
              </div>
            </v-card-title>
            <v-card-text>       
              <v-text-field v-model="selectedPaper.extraDescription"
                            label="Extra beskrivning"                     
              >
                <template v-slot:append>
                  <v-fade-transition leave-absolute>
                    <v-progress-circular
                      v-if="saving"
                      size="24"
                      color="info"
                      indeterminate
                    />
                    <v-icon v-else
                            @click="save"
                    >
                      save
                    </v-icon>
                  </v-fade-transition>
                </template>
              </v-text-field>
            </v-card-text>
          </v-card>  
        </v-col>
        <v-col cols="6">
          <v-card max-height="300">
            <v-card-title>Väntande bilder</v-card-title>
            <v-card-text>
              <v-list-item v-for="(paper,index) in notPublishedPapers" :key="index">                
                <v-list-item-title>{{ paper.name }} Uppladdade: {{ paper.localTime|toLocalDate }}</v-list-item-title>                                  
              </v-list-item>            
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>    

    <v-file-input label="Choose a file" @change="selectFile" />
    <v-btn color="success" dark small @click="uploadFile">
      Upload
      <v-icon right dark>
        mdi-cloud-upload
      </v-icon>
    </v-btn>
    <v-btn color="warning" dark small @click="reset">
      Reset
      <v-icon right dark>
        mdi-cancel
      </v-icon>
    </v-btn>
    <v-container class="pb-0">
      <h2>Dagens produkter</h2>
      <v-row>
        <v-col v-for="(magazines, title) in papers" :key="title" cols="5">
          <h1 class="text-h5 mb-4">
            {{ title }}
          </h1>
          <v-row>
            <v-col v-for="paper in magazines" :key="paper.Id" cols="6">
              <v-card
                light
                elevation="10"
                class="mb-4"                
                @click="selectMagazine(paper)"
              >
                <!-- <v-layout>
                  <v-flex> -->
                <v-img
                  :src="paper.coverUrl"                               
                  contain                    
                  height="350"
                />
                <v-card-title primary-title class="pt-2">
                  <div>
                    <div class="text-h5">
                      {{ paper.description }}
                    </div>
                    <div style="min-height: 34px;">
                      <span v-if="paper.extraDescription">{{ paper.extraDescription }}</span>
                      <span v-else style="visibility: hidden;">&nbsp;</span>
                    </div>
                    <div>
                      {{ paper.startDate | paperDate }} -
                      {{ paper.endDate | paperDate }}
                    </div>
                    <div>Pris: {{ paper.price }} kr</div>
                    <div>EAN: {{ paper.eanCode }}</div>
                  </div>
                </v-card-title>
                <!-- </v-flex>
                </v-layout> -->
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>
import api from '@/backend/api'
import adminApi from '@/backend/adminapi'
import log from '@/logger'
import { orderBy} from 'lodash'
export default {
  name: 'DailyProductUpload',
  data() {
    return {
      papers: {},
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substring(0, 10),
      dateModal: false,
      currentFile: undefined,
      selectedPaper: undefined,
      publishers:[
        {name:'Välj tidning', value:-1},
        {name:'Aftonbladet', value:1},
        {name:'Expressen', value:2}],
      selectedPublisher: null,
      selectedEdition: {},
      paperEditions:[],
      extraDescription:'',
      saving:false,
      notPublishedPapers:[]
    }
  },
  computed: {
    paperNotSelected() {
      return (
        this.selectedPaper === undefined ||
        Object.keys(this.selectedPaper).length === 0
      )
    },
    paperSelected(){
      return (this.selectedPublisher !== undefined || this.selectedPublisher !== null) &&
             (this.selectedEdition !== undefined && Object.keys(this.selectedEdition).length > 0)
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      api
        .getAllPaperInfo()
        .then((resp) => {
          this.papers = resp.data
          log.debug('Daily products:' + resp.data)
        })
        .catch((error) => {
          self.loading = false
          log.debug('Error uploading file:', error)
        })

        this.loadNotPublished()              
    },
    loadNotPublished(){
      adminApi
        .adminGetDailyProductsNotPublished()
        .then((resp) => {
          this.notPublishedPapers = orderBy(resp.data,['localTime'],['desc'])
          log.debug('Not published  products:' + resp.data)
        })
        .catch((error) => {
          self.loading = false
          log.debug('Error uploading file:', error)
        })
    },
    selectFile(file) {
      this.currentFile = file
    },
    reset() {
      this.selectedPaper = {}
      this.selectedPublisher = null
      this.paperEditions = []
      this.selectedEdition = {}
    },
    uploadFile() {
      const formData = new FormData()
      formData.append('file', this.currentFile)
      formData.append('date', this.date)

      if(this.paperNotSelected){        
        formData.append('titleId', this.selectedEdition.titleId)
        formData.append('editionId',  this.selectedEdition.editionId)        
        formData.append('filename', this.createFileName())
        formData.append('published',false)
      }else {
        formData.append('titleId', this.selectedPaper.titleId)
        formData.append('editionId',  this.selectedPaper.utgavaId)
        formData.append('filename', this.selectedPaper.coverPic)
        formData.append('published',true)
      }         

      adminApi
        .adminUploadDailyProduct(formData)
        .then((resp) => {
          log.debug('File uploaded:', resp.data)
          this.loadNotPublished()

        })
        .catch((error) => {
          self.loading = false
          log.debug('Error uploading file:', error)
        })
    },
    save(){
      this.saving= true
      const formData = new FormData()
      

      if(this.paperNotSelected){        
        formData.append('titleId', this.selectedEdition.titleId)
        formData.append('editionId',  this.selectedEdition.editionId)           
        formData.append('description',  this.extraDescription)           
        formData.append('date',  this.date)           
      }else {
        formData.append('titleId', this.selectedPaper.titleId)
        formData.append('editionId',  this.selectedPaper.utgavaId)
        formData.append('description',  this.selectedPaper.extraDescription)           
        formData.append('date',  this.selectedPaper.startDate)
      }         
      adminApi
        .adminSaveDescription(formData)
        .then((resp) => {
          log.debug('Description saved:', resp.data)
          this.saving= false
          this.loadData()
        })
        .catch((error) => {
          this.saving= false
          log.debug('Error saving description:', error)
        })
    },

    selectMagazine(paper) {
        this.reset() 
      this.selectedPaper = paper
      window.scrollTo(0, 0) 
      log.debug('Selected paper:' + paper)

    },
    createFileName(){
        if(this.selectedPublisher === 1){
            return this.selectedEdition.code+'Z1_'+this.date.replace(/-/g,'')+'_E1_S1_V1_001.jpg'
        }
        if(this.selectedPublisher === 2){
            return this.selectedEdition.code+'_'+ this.selectedEdition.editionId.toString().padStart(3,'0')+'_'+this.date.replace(/-/g,'')+'.jpg'
        }
    },
    publisherSelected(){
        if(this.selectedPublisher > 0){
          adminApi.adminGetDailyProducts(this.selectedPublisher)
            .then(resp=>{
                this.paperEditions = resp.data
                log.debug('Editions :',resp.data)
            })
        }
    }
  },
}
</script>
<style scoped>

html {
  overflow: hidden !important;
}

.v-card {
  display: flex !important;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
}
</style>